import {
    convertUniversalDateToPersianDate,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    showErrorMessage,
    RaikoTableTitleContainer, RaikoCustomTable,
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    RaikoCustomSimpleChip,
    RaikoChipTypes
} from "@moeindal/base-raiko-panel-components";
import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {NotificationsService} from "../../serverService/notificationsService/NotificationsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {Add} from "@mui/icons-material";
import AddNewNotification from "./AddNewNotification";
import {addNewRowToTable} from "../../util/TableProvider";
import {useNavigate} from "react-router-dom";

export default function NotificationsList() {
    let page = 0;
    const size = 20;

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getNotificationListFromServer()
        }
    }, []);

    const [numberOfItems, setNumberOfItems] = useState(0)
    const [tableLoading, setTableLoading] = useState(false)
    const [notificationData, setNotificationData] = useState([])
    const [pageCount, setPageCount] = useState(0)

    const service = new NotificationsService()

    function getNotificationListFromServer() {
        setTableLoading(true)
        service.getNotificationList(page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setNotificationData([])
                response.data.map((item, index) => {
                    setNotificationData((prevState => [
                        ...prevState,
                        tablePreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.postedAt,
                            item.enabled,
                        )
                    ]))

                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePage(newPage) {
        page = newPage;
        getNotificationListFromServer()
    }

    function tablePreparation(id, number, title, date, enabled) {
        return {
            id: id,
            number: number,
            title: title,
            date: convertUniversalDateToPersianDate(date),
            enabled: enabled ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    const [openDialog, setOpenDialog] = useState(false)

    function handleOpenDialog() {
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
    }


    function handleAddNewNotificationAndInsertToTable(item) {
        const newItems = addNewRowToTable(
            tablePreparation(
                item.id,
                1,
                item.title,
                item.postedAt,
                item.enabled,
            ),
            notificationData
        )
        setNotificationData(newItems)
        handleCloseDialog()
    }

    const navigate = useNavigate()

    function showNotificationDetail(notificationId) {
        let _notificationTitle = ""
        notificationData.map((item) => {
            if (item.id === notificationId)
                _notificationTitle = item.title
        })
        navigate(RouteHelper.NotificationsDetail.globalUrl.replace(":id", notificationId),
            {state: {title: _notificationTitle}, replace: false}
        )
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.NotificationsList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                pageTitle={"افزودن اطلاعیه جدید"}
                open={openDialog}
                dialogSize={DialogSize.LARGE}
                onClose={handleCloseDialog}
            >
                <AddNewNotification
                    handleAddNewNotification={handleAddNewNotificationAndInsertToTable}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.NotificationsList.name, "")
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                            <RaikoTableTitleContainer
                                title={RouteHelper.NotificationsList.name}
                                hasCreateNewItem={true}
                                amount={numberOfItems}
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={notificationTableColumns}
                                isLoading={tableLoading}
                                data={notificationData}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePage}
                                rowClicked={showNotificationDetail}
                            />
                        </RaikoGridOneColumn>

                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}
const notificationTableColumns = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'date',
        label: 'تاریخ',
    },
    {
        id: 'enabled',
        label: 'وضعیت',
    },
]